// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.icon-circle-yellow[data-v-454e3a76] {\n  border: 3px solid #fbc02d;\n  border-radius: 50px\n}\n.dialog-text[data-v-454e3a76] {\n  line-height: 1.5rem !important;\n  letter-spacing: .0178571429em !important;\n}\n", ""]);
// Exports
module.exports = exports;
